import { CaseNavSidebar } from "src/cases/CaseNavSidebar";
import { DashboardContent } from "src/layout/DashboardContent";
import { PageHeader } from "src/layout/PageHeader";
import { DashboardPageParams, getUrlToCaseQueuePage } from "src/router/urls";
import { useParamsDecode } from "src/utils/useParamsDecode";

type IntermediateBreadcrumb = {
  key: string;
  label: string;
  href?: string;
};

type CasePageLayoutProps = {
  breadcrumbLabel: string;
  breadcrumbHref: string;
  intermediateBreadcrumbs?: IntermediateBreadcrumb[];
  headerActions?: React.ReactNode;
  rightPanel?: React.ReactNode;
  removePadding?: boolean;
  children: React.ReactNode;
};

export const CasePageLayout: React.FC<CasePageLayoutProps> = ({
  breadcrumbLabel,
  breadcrumbHref,
  intermediateBreadcrumbs,
  headerActions,
  rightPanel,
  removePadding,
  children,
}) => {
  const { orgId, wsId } = useParamsDecode<DashboardPageParams>();

  return (
    <div className="relative flex max-h-screen min-h-0 grow overflow-hidden">
      <div className="flex max-h-screen min-h-0 min-w-0 grow flex-col">
        <PageHeader
          breadcrumbs={[
            {
              key: "cases-page",
              breadcrumb: (
                <PageHeader.Breadcrumb
                  dataLoc="cases-page"
                  href={getUrlToCaseQueuePage({ orgId, wsId })}
                  label="Cases"
                  hideIcon
                />
              ),
            },
            ...(intermediateBreadcrumbs ?? []).map((crumb) => ({
              key: crumb.key,
              breadcrumb: crumb.href ? (
                <PageHeader.Breadcrumb
                  dataLoc={crumb.key}
                  href={crumb.href}
                  label={crumb.label}
                />
              ) : (
                <PageHeader.Breadcrumb dataLoc={crumb.key}>
                  <span className="truncate font-inter-semibold-13px text-gray-800">
                    {crumb.label}
                  </span>
                </PageHeader.Breadcrumb>
              ),
            })),
            {
              key: "case-subpage",
              breadcrumb: (
                <PageHeader.Breadcrumb
                  dataLoc="case-subpage"
                  href={breadcrumbHref}
                  label={breadcrumbLabel}
                  active
                />
              ),
            },
          ]}
          sideContent={headerActions}
        />
        <DashboardContent
          sidebar={<CaseNavSidebar />}
          removePadding={removePadding}
        >
          {children}
        </DashboardContent>
      </div>
      {rightPanel}
    </div>
  );
};
